import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatArticleDate } from "../blogs/articleHelpers";
import { questionsUrl } from "./questionHelpers";
import Breadcrumbs from "../content/Breadcrumbs";
import EditorialBadge from "../content/EditorialBadge";
import "./questions.css";
import { currentLang } from "../../shared/seo/links";

// crumbs: [{ name, path }] (see pages/questions/Question.jsx); without them,
// a link back to the list.
export default function QuestionBody({ question, crumbs }) {
  const Lng = currentLang();
  const { t } = useTranslation();
  return (
    <article className="avc-question">
      {crumbs ? (
        <Breadcrumbs items={crumbs} />
      ) : (
        <Link to={questionsUrl(Lng)} className="avc-article__back">
          <i
            className={Lng === "ar" ? "fas fa-arrow-right" : "fas fa-arrow-left"}
            aria-hidden="true"
          ></i>
          {t("qa_back")}
        </Link>
      )}
      <div className="avc-question__head">
        <span className="avc-question-card__badge" aria-hidden="true">
          {Lng === "ar" ? "س" : "Q"}
        </span>
        <div>
          {question.editorial ? <EditorialBadge /> : <span className="avc-tag">{t("qa_question_label")}</span>}
          <h1 className="avc-question__title" dir="auto">
            {question.title}
          </h1>
          {question.createdAt && (
            <time className="avc-question__date" dateTime={question.createdAt}>
              <i className="far fa-clock" aria-hidden="true"></i>
              {formatArticleDate(question.createdAt, Lng)}
            </time>
          )}
        </div>
      </div>
      {/* Written by a visitor: plain text only, line breaks kept by CSS. */}
      <div className="avc-question__content" dir="auto">
        {question.content}
      </div>
    </article>
  );
}
